<template>
  <q-form ref="form" class="full-width q-px-md">
    <div class="row">
      <div class="col-12">
        <q-tabs v-model="tab" align="left">
          <q-tab name="general" label="General" />
          <q-tab
            v-if="formData.multipleEventsPerAthlete"
            name="individualEntry"
            label="Enter Individuals"
            @click="closeEdit"
          />
          <q-tab
            v-if="formData.teamsPlayersEntries"
            name="teamEntry"
            label="Enter Teams"
            @click="closeEdit"
          />
          <q-tab name="supportPeopleEntry" label="Enter Support People" />
        </q-tabs>
      </div>
    </div>
    <div class="row" v-if="tab == 'general'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">{{ formData.competition_name }}</h6>
      </div>
      <div
        class="col-12 bg-blue-grey rounded-borders q-pa-sm text-white text-center"
        v-if="draftEntries"
      >
        You Currently have <b>{{ draftEntries }}</b> entr{{
          draftEntries > 1 ? "ies" : "y"
        }}
        that {{ draftEntries > 1 ? "are" : "is" }} not submitted
      </div>

      <div class="col-12 col-md-5 q-mb-md q-px-sm">
        <div class="row q-mt-md">
          <!-- <div class="col-12 q-pb-sm">
            {{ formData.noticeTop }}
          </div> -->
          <!-- <div class="col-12">
            <b>Early Entry Close Date: </b>
            {{ moneyFormatter(formData.compEarlyEntry) }},
            {{
              momentFormat(
                formData.compStandardEntryDate,
                false,
                "MMMM Do YYYY"
              )
            }}
            <br />
            <b>Standard Entry Close Date: </b>
            {{ moneyFormatter(formData.compStandardEntry) }},
            {{
              momentFormat(formData.compLateEntryDate, false, "MMMM Do YYYY")
            }}
            <br />
            <b>Late Entry Close Date: </b>
            {{ moneyFormatter(formData.compLateEntry) }},
            {{ momentFormat(formData.entriesCloseDate, false, "MMMM Do YYYY") }}
          </div> -->
          <div class="col-12 q-mt-md">
            <div v-html="formData.entryInformationSection"></div>
          </div>

          <!-- <div class="col-12 q-mt-md">
            <p class="q-ma-none subHeader">Entry Information</p>
          </div>
          <div class="col-12">
            <ul>
              <li>Links</li>
              <li>Times</li>
              <li>Programme</li>
            </ul>
          </div> -->
          <div class="col-12 q-mt-md">
            <div class="row">
              <div class="col-12 col-md-6 q-px-sm">
                <q-btn
                  no-caps
                  color="primary"
                  class="q-ma-sm full-width"
                  @click="downloadEntriesReport"
                >
                  Entries Report
                </q-btn>
              </div>
              <div class="col-12 col-md-6 q-px-sm">
                <q-btn
                  no-caps
                  color="primary"
                  class="q-ma-sm full-width"
                  @click="downloadFeesReport"
                >
                  Fees Report
                </q-btn>
              </div>
            </div>
          </div>
          <div class="col-12">
            {{ formData.noticeBottom }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-7 q-pa-sm">
        <div class="row">
          <div class="col-12 col-md-6 q-mb-md">
            <q-card flat bordered>
              <q-card-section class="q-pa-sm q-pl-md">
                <div class="row items-center">
                  <div style="display: inline-block" class="text-h6">
                    Contact Person
                  </div>
                </div>
              </q-card-section>
              <q-separator />
              <q-card-section class="q-pa-sm q-pl-md">
                <div class="row">
                  <div class="col-12 q-my-sm">
                    <q-icon name="mdi-account" size="sm"></q-icon>
                    {{ formData.contactName }}
                  </div>
                  <div class="col-12 q-my-sm">
                    <q-icon
                      name="mdi-phone"
                      size="sm"
                      v-if="formData.phone"
                    ></q-icon>
                    {{ formData.phone }}
                    <span v-if="formData.mobile && formData.phone">|</span>
                    <q-icon
                      name="mdi-phone"
                      size="sm"
                      v-if="formData.mobile"
                    ></q-icon>
                    {{ formData.mobile }}
                  </div>
                  <div class="col-12 q-my-sm">
                    <q-icon name="mdi-email " size="sm"></q-icon>
                    {{ formData.email }}
                  </div>
                </div>
              </q-card-section>
            </q-card>
          </div>
          <div class="col-12 col-md-6">
            <div
              class="q-pb-sm"
              :style="
                `width: ${$q.screen.gt.sm ? '355px' : '100%'}; margin: auto`
              "
            >
              <q-img
                v-if="formData.logoUrl"
                :src="formData.logoUrl"
                :style="
                  `width: ${$q.screen.gt.sm ? '355px' : '100%'}; height: 200px`
                "
              ></q-img>
              <q-img
                v-if="!formData.logoUrl"
                src="/statics/wavesLogo.png"
                contain
                style="height: 70px"
              ></q-img>
            </div>
            <div
              v-if="formData.youtubeVideoID"
              class="q-pt-sm"
              :style="
                `margin: auto; width: ${
                  $q.screen.gt.sm ? '355px' : '100%'
                }; position:relative;padding-top:56.25%;`
              "
            >
              <iframe
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                "
                :src="
                  `https://www.youtube-nocookie.com/embed/${getYoutubeID(
                    formData.youtubeVideoID
                  )}`
                "
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-12 q-pa-sm">
        <q-btn
          class="full-width"
          color="positive"
          @click="tab = 'individualEntry'"
        >
          Enter Individuals
        </q-btn>
      </div>
      <div class="col-12 q-pa-sm">
        <q-btn class="full-width" color="positive" @click="tab = 'teamEntry'">
          Enter Teams
        </q-btn>
      </div>
      <div class="col-12 q-pa-sm">
        <q-btn
          class="full-width"
          color="positive"
          @click="tab = 'supportPeopleEntry'"
        >
          Enter Support People
        </q-btn>
      </div> -->
    </div>
    <div class="row" v-if="tab == 'individualEntry'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          Individuals Entered

          <q-btn
            v-if="!addIndividualEntry && !editIndividualEntry"
            class="q-ml-md"
            color="primary"
            text-color="white"
            no-caps
            @click="addIndividualEntry = true"
          >
            <q-icon
              name="mdi-plus-circle"
              color="white"
              class="q-mr-sm"
              size="xs"
            ></q-icon>
            Add
          </q-btn>

          <q-btn
            v-if="addIndividualEntry"
            class="float-left"
            flat
            @click="addIndividualEntry = false"
          >
            <q-icon name="mdi-arrow-left"></q-icon>
          </q-btn>
          <q-btn
            v-if="editIndividualEntry"
            class="float-left"
            flat
            @click="$router.push(`/entries/competitions/${id}`)"
          >
            <q-icon name="mdi-arrow-left"></q-icon>
          </q-btn>
          <q-input
            v-if="!addIndividualEntry && !editIndividualEntry"
            style="max-width: 70%"
            filled
            class="float-right"
            v-model="indivudualEntriesSearch"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
        </h6>
      </div>
      <div
        v-if="!addIndividualEntry && !editIndividualEntry"
        class="col-12"
        style="height: calc(100vh - 285px) !important"
      >
        <datatable
          :filter="indivudualEntriesSearch"
          :flat="true"
          :data="individualEvents"
          :columns="individualEntryColumns"
          @rowDoubleClick="individualEntryDoubleClick"
        >
          <template slot="body-cell-events" slot-scope="data">
            <q-td :props="data.props">
              <div class="row" style="width: 800px">
                <div class="col-12">
                  <q-btn
                    v-on:click.stop="
                      toggleExpandedEvent($event, data.props.row.id)
                    "
                    size="md"
                    flat
                    no-caps
                  >
                    Expand
                    <q-icon
                      v-if="!expandedEventIDs.includes(data.props.row.id)"
                      name="mdi-chevron-down"
                    ></q-icon>
                    <q-icon v-else name="mdi-chevron-up"></q-icon>
                  </q-btn>
                </div>
                <div
                  class="col-12"
                  v-if="expandedEventIDs.includes(data.props.row.id)"
                >
                  <div class="row">
                    <div
                      class="col-12 col-lg-6 q-pa-xs"
                      v-for="(event, eventIndex) in data.props.row.events"
                      :key="`${eventIndex}_Event`"
                    >
                      <div class="row">
                        <div class="col-12">
                          <q-icon
                            :color="
                              event.status == 'Draft' ? 'blue-grey' : 'positive'
                            "
                            :name="
                              event.status == 'Draft'
                                ? 'mdi-pencil'
                                : 'mdi-check-circle-outline'
                            "
                            size="md"
                          >
                          </q-icon>
                          <b>{{ event.event_name }}</b>

                          <span
                            v-if="event.qualMark"
                            class="text-italic text-gray"
                          >
                            Qual Time {{ event.qualMark }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </q-td>
          </template>
          <template slot="body-cell-containsDraftEntry" slot-scope="data">
            <q-td :props="data.props">
              <q-icon
                :name="
                  data.props.row.containsDraftEntry
                    ? 'mdi-alert-circle-outline'
                    : 'mdi-check-circle-outline'
                "
                size="sm"
                :color="
                  data.props.row.containsDraftEntry ? 'orange' : 'positive'
                "
              >
                <q-tooltip v-if="data.props.row.containsDraftEntry">
                  This member has events that are current not confirmed
                </q-tooltip>
              </q-icon>
            </q-td>
          </template>
          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn
                :loading="removingIndividualEntryID == data.props.row.id"
                @click="removeIndividualEntry(data.props.row.id)"
                round
                flat
                color="negative"
              >
                <q-icon name="mdi-trash-can-outline"></q-icon>
                <q-tooltip>Remove Entry</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </datatable>
      </div>
      <div v-if="addIndividualEntry" class="col-12">
        <individualEntryForm
          ref="addIndividualEntryForm"
          forAssociation
          @close="addIndividualEntry = false"
          @loadingStateChanged="state => (addIndividualEntryLoading = state)"
        />
      </div>
      <div v-if="editIndividualEntry" class="col-12">
        <individualEntryForm
          ref="editIndividualEntryForm"
          forAssociation
          :id="$route.params.enterIndividual_id"
          @close="$router.push(`/entries/competitions/${id}`)"
          @loadingStateChanged="state => (editIndividualEntryLoading = state)"
        />
      </div>
    </div>
    <div class="row" v-if="tab == 'teamEntry'">
      <div class="col-12">
        <h6 class="q-my-none q-mt-xs">
          Team Events

          <q-btn
            v-if="editTeamEntry"
            class="float-left"
            flat
            @click="
              $router.push(`/entries/competitions/${id}`);
              $store.dispatch(`events/loadForCompetition`, id);
            "
          >
            <q-icon name="mdi-arrow-left"></q-icon>
          </q-btn>
          <q-input
            v-if="!editTeamEntry"
            style="max-width: 70%"
            filled
            class="float-right"
            v-model="teamEntriesSearch"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"> </q-icon>
            </template>
          </q-input>
        </h6>
      </div>
      <div
        v-if="!editTeamEntry"
        class="col-12"
        style="height: calc(100vh - 285px) !important"
      >
        <datatable
          :filter="teamEntriesSearch"
          :flat="true"
          :data="teamEvents"
          :columns="teamEntryColumns"
          @rowDoubleClick="teamEntryDoubleClick"
        >
          <template slot="body-cell-teams" slot-scope="data">
            <q-td :props="data.props">
              <div class="row">
                <div class="col-12">
                  <q-btn
                    v-on:click.stop="
                      toggleExpandedTeam($event, data.props.row.id)
                    "
                    size="md"
                    flat
                    no-caps
                  >
                    Expand
                    <q-icon
                      v-if="!expandedTeamsIDs.includes(data.props.row.id)"
                      name="mdi-chevron-down"
                    ></q-icon>
                    <q-icon v-else name="mdi-chevron-up"></q-icon>
                  </q-btn>
                </div>
                <div
                  class="col-12"
                  v-if="expandedTeamsIDs.includes(data.props.row.id)"
                >
                  <div class="row">
                    <div
                      class="col-12 col-lg-6 q-pa-sm"
                      v-for="(team, teamIndex) in data.props.row.teams"
                      :key="`${teamIndex}_Team`"
                    >
                      <q-card style="height: 100%">
                        <q-card-section>
                          <div class="row">
                            <div class="col-12">
                              <b>{{ team.team_name }}</b>
                              <q-icon
                                :color="
                                  team.status == 'draft'
                                    ? 'blue-grey'
                                    : 'positive'
                                "
                                :name="
                                  team.status == 'draft'
                                    ? 'mdi-pencil'
                                    : 'mdi-check-circle-outline'
                                "
                                class="float-right"
                                size="md"
                              >
                              </q-icon>
                            </div>
                            <div
                              class="col-12"
                              v-for="(member, memberIndex) in team.members"
                              :key="`${memberIndex}_TeamMember`"
                            >
                              <b>
                                {{ member.firstName }} {{ member.lastName }}
                              </b>
                              -
                              {{ member.playerLabel }}
                            </div>
                          </div>
                        </q-card-section>
                      </q-card>
                    </div>
                  </div>
                </div>
              </div>
            </q-td>
          </template>
          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn
                :loading="removingTeamEntryID == data.props.row.id"
                @click="removeTeamEntry(data.props.row.id)"
                round
                flat
                color="negative"
              >
                <q-icon name="mdi-trash-can-outline"></q-icon>
                <q-tooltip>Remove Entry</q-tooltip>
              </q-btn>
            </q-td>
          </template>
        </datatable>
      </div>
      <div v-if="editTeamEntry" class="col-12">
        <teamEntryForm
          ref="editTeamEntryForm"
          forAssociation
          :id="$route.params.enterTeam_id"
          @close="
            $router.push(`/entries/competitions/${id}`);
            $store.dispatch(`events/loadForCompetition`, id);
          "
          @loadingStateChanged="state => (editTeamEntryLoading = state)"
        />
      </div>
    </div>
    <div class="row" v-if="tab == 'supportPeopleEntry'">
      <div
        class="col-12"
        v-for="(question, index) in questions"
        :key="`question_${index}`"
      >
        <div class="row">
          <div class="col-12">
            <h3 style="font-size: 20px" class="q-my-sm">
              {{ question.questionName }}
            </h3>
            <q-separator></q-separator>
          </div>
          <div
            v-if="question.rangeType == 0 && question.range == 2"
            v-for="n in Math.ceil(athletesAssociationCount / 10)"
            :key="`${question.id}_${n}`"
            class="col-12"
          >
            <questionInputForm
              :question="question"
              :index="n"
              required
              :competition_id="id"
            />
          </div>

          <div
            v-if="question.rangeType == 0 && question.range == 0"
            class="col-12"
          >
            <questionInputForm
              :question="question"
              :index="0"
              required
              :competition_id="id"
            />
          </div>

          <div
            v-if="question.rangeType == 1"
            v-for="n in question.max"
            :key="`${question.id}_${n}`"
            class="col-12"
          >
            <questionInputForm
              :question="question"
              :index="n"
              :required="n <= question.min"
              :competition_id="id"
            />
          </div>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import individualEntryForm from "@/components/competitions/individualEntryForm.vue";
import teamEntryForm from "@/components/competitions/teamEntryForm.vue";
import questionInputForm from "@/components/questionTypes/questionInputForm.vue";
import moment from "moment";
import api from "@/api.js";

export default {
  components: {
    datatable,
    individualEntryForm,
    teamEntryForm,
    questionInputForm
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      competitionTypes: "settings/competitionTypes",
      poolLengthOptions: "settings/poolLengthOptions",
      competitionStatusOptions: "settings/competitionStatusOptions",
      data: "competitions/current",
      dataLoading: "competitions/currentLoading",
      divisions: "divisions/list",
      divisionsLoading: "divisions/listLoading",
      events: "events/listForCompetition",
      eventsLoading: "events/listForCompetitionLoading",
      teamEvents: "events/teamListForCompetitionOrderedDivision",
      individualEvents: "eventsEntries/individualList",
      individualEventsLoading: "eventsEntries/individualListLoading",
      questions: "questions/listForCompetition",
      questionsLoading: "questions/listForCompetitionLoading",
      athletesAssociationCount: "competitions/athletesAssociationCount",
      athletesAssociationCountLoading:
        "competitions/athletesAssociationCountLoading"
    }),
    draftEntries() {
      let count = 0;
      this.individualEvents.forEach(x => {
        x.events.forEach(y => {
          if (y.status == "Draft") {
            count++;
          }
        });
      });

      this.teamEvents.forEach(x => {
        x.teams.forEach(y => {
          if (y.status == "draft") {
            count++;
          }
        });
      });
      return count;
    }
  },
  props: {
    id: {
      default: null
    }
  },
  watch: {
    id: function() {
      this.init();
    },
    data: function() {
      this.init();
    },
    $route: function() {
      this.handleRoute();
    }
  },
  data: () => ({
    // Extra Data
    formData: {},
    tab: "general",

    // Individual Entry
    individualEntryColumns: [
      {
        name: "athlete",
        label: "Athlete",
        align: "left",
        field: row => row,
        format: val => `${val.firstName} ${val.lastName}`,
        sortable: true,
        style:
          "width: 300px; min-width: 300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; vertical-align: top; padding-top: 15px !important"
      },
      {
        name: "eventsCount",
        label: "# Events",
        align: "left",
        field: "eventsCount",
        style:
          "width: 80px; min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; vertical-align: top; padding-top: 15px !important",
        sortable: true
      },
      {
        name: "events",
        label: "EventsEntered",
        align: "left",
        field: "events",
        style:
          "width: 800px; min-width: 800px;max-width: 800px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; vertical-align: top; padding-top: 15px !important",
        sortable: true
      },
      {
        name: "containsDraftEntry",
        label: "Confirmed",
        align: "left",
        field: "containsDraftEntry",
        sortable: true
      }
    ],
    addIndividualEntry: false,
    addIndividualEntryLoading: false,
    indivudualEntriesSearch: "",
    removingIndividualEntryID: null,
    editIndividualEntry: false,
    editIndividualEntryLoading: false,

    expandedEventIDs: [],
    allEventsExpanded: false,

    // Team Entry
    teamEntryColumns: [
      {
        name: "event_name",
        label: "Team Event",
        align: "left",
        field: "event_name",
        style:
          "width: 400px; min-width: 400px;max-width: 400px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; vertical-align: top; padding-top: 15px !important",
        // format: (val) => `${val.firstName} ${val.lastName}`,
        sortable: true
      },
      {
        name: "assocTeamEntries",
        label: "# Teams Entered",
        align: "left",
        field: "assocTeamEntries",
        style:
          "width: 80px; min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; vertical-align: top; padding-top: 15px !important",
        sortable: true
      },
      {
        name: "teams",
        label: "Teams",
        align: "left",
        field: "teams",
        sortable: true
      }
    ],
    teamEntriesSearch: "",
    removingTeamEntryID: null,
    editTeamEntry: false,
    editTeamEntryLoading: false,

    expandedTeamsIDs: [],
    allTeamsExpanded: false
  }),
  beforeCreate() {},
  mounted() {
    this.init();
    this.handleRoute();
    this.$store.dispatch("competitions/loadByID", this.id);
    this.$store.dispatch("divisions/loadAll");
    this.$store.dispatch("events/loadForCompetition", this.id);
    this.$store.dispatch(
      "eventsEntries/loadAllIndividualEntriesForCompetition",
      this.id
    );
    this.$store.dispatch(
      "associations/loadByID",
      this.currentUserData.currentAssociation_id
    );
    this.$store.dispatch("associations/loadMembersForAssociation", {
      id: this.currentUserData.currentAssociation_id
    });
    this.$store.dispatch("questions/loadForCompetition", this.id);
    this.$store.dispatch("competitions/loadAthletesForAssociationCount", {
      competition_id: this.id,
      associations_id: this.currentUserData.currentAssociation_id
    });
    this.$store.dispatch("questions/loadAnswersForCompetition", {
      id: this.id,
      entries: 1
    });
  },
  methods: {
    init() {
      if (this.data != null && this.data.id == this.id) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      } else {
        this.formData = {};
      }
    },
    handleRoute() {
      if (this.$route.params.enterIndividual_id) {
        this.editIndividualEntry = true;
        this.tab = "individualEntry";
      } else {
        this.editIndividualEntry = false;
      }

      if (this.$route.params.enterTeam_id) {
        this.editTeamEntry = true;
        this.tab = "teamEntry";
      } else {
        this.editTeamEntry = false;
      }
    },
    getYoutubeID(url) {
      // console.log(url);
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    },

    // Individual Entries
    individualEntryDoubleClick(row) {
      this.$router.push(
        `/entries/competitions/${this.id}/enterIndividual/${row.associationsMembers_id}`
      );
    },

    // Team Entries
    teamEntryDoubleClick(row) {
      this.$router.push(`/entries/competitions/${this.id}/enterTeam/${row.id}`);
    },

    toggleExpandedTeam($event, id) {
      $event.preventDefault();

      if (this.expandedTeamsIDs.includes(id)) {
        this.expandedTeamsIDs = this.expandedTeamsIDs.filter(x => x != id);
      } else {
        this.expandedTeamsIDs.push(id);
      }
    },
    toggleExpandedEvent($event, id) {
      $event.preventDefault();

      if (this.expandedEventIDs.includes(id)) {
        this.expandedEventIDs = this.expandedEventIDs.filter(x => x != id);
      } else {
        this.expandedEventIDs.push(id);
      }
    },
    closeEdit() {
      this.$router.push(`/entries/competitions/${this.id}`);
    },
    downloadEntriesReport() {
      window.open(
        `https://api.live.simplesoftware.nz/waves/report/download?type=CompetitionEntries&competitions_id=${this.id}&association_id=${this.currentUserData.currentAssociation_id}`,
        "_blank"
      );
    },
    downloadFeesReport() {
      window.open(
        `https://api.live.simplesoftware.nz/waves/report/download?type=CompetitionEntriesFees&competitions_id=${this.id}&association_id=${this.currentUserData.currentAssociation_id}`,
        "_blank"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.formSubTitle {
  font-weight: bold;
}

.subHeader {
  font-weight: bold;
  font-size: 14pt;
}

.btn-width {
  width: 90% !important;
}
</style>
